// extracted by mini-css-extract-plugin
export default {"txt":"Card_txt__abGFH"};